import { MerchantSettingsContainer } from '@/modules/MerchantSettings';
import { MerchantSyncContainer } from '@/modules/MerchantSync';

export const MerchantSettings = (): JSX.Element => (
  <>
    <MerchantSettingsContainer />
    <MerchantSyncContainer />
  </>
);

export default MerchantSettings;
